export default "__VITE_ASSET__XcAlRWBz__"